import { render, staticRenderFns } from "./micro-dashboard.vue?vue&type=template&id=18c4b840&"
import script from "./micro-dashboard.vue?vue&type=script&lang=js&"
export * from "./micro-dashboard.vue?vue&type=script&lang=js&"
import style0 from "./micro-dashboard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports